import React, { Component } from "react";

class ComingSoon extends Component
{
    render() {
        return (
            <div id="coming-soon-wrapper" className="d-flex text-light justify-content-center align-items-center">
                <h1 className="text-center">Coming Soon</h1>
            </div>
        );
    }
}

export default ComingSoon